import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from "mui-datatables";
import {MuiThemeProvider } from '@material-ui/core/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import PoDialog from '../CreateDialogue/PoDialog';
import moment from "moment";
import PoAmendmentDialog from '../CreateDialogue/PoAmendmentDialog';
import EditPoDialog from '../EditDialogue/EditPoDialog';
import EditPoAmendmentDialog from '../EditDialogue/EditPoAmendmentDialog';
import EditPOProjecLabs from '../EditDialogue/EditPOLabProject';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles((theme) => ({
    root: {
        "& .MuiSvgIcon-root": {
            color: "#1f1b1e",
            colorPrimary: "#1f1b1e",
            fill: "#1f1b1e",
        },
    },
}));
export default function PoTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [productOrders, setProductOrders] = React.useState([]);
    const classes = pageStyles();
	const [isLoading, setIsLoading] = React.useState(true);
    const [amendmentsPo, setamendmentsPo] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState("");
    

    const handleDialogCallback = async (childData) => {
        const response = await fetch("api/PO", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "PO": [{
                    "SOWID": childData.SOWID,
                    "IsAllProjects": childData.IsAllProjects,
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "PoNumber": childData.PoNumber,
                    "SoldToID": childData.SoldToID,
                    "ShipToID": childData.ShipToID,                 
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "Owner": childData.Owner,
                    "Email": childData.Email,
                    "EmailGroup": childData.EmailGroup,
                    "Amount": childData.Amount,
                    "IsBillable": childData.IsBillable,
                    "IsActive": childData.IsActive
                }],
                "ImportLP": childData.ImportLP,
        		"POID": childData.POID
            })
        })
        .then(res =>  {
				console.log("response="+res);
				const json = res.json();
				if (json.code === "ER_DUP_ENTRY" || json.code === "Cannot create outside of sow dates") {
					setAlertText(json.sqlMessage || json.message);
					setAlert(true);
				}
				return json;
			});
        logger(childData);
        setRefresh(true);
        return response;
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };

    /*const handleEditCallback = (childData) => {
        fetch("api/PO", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "PO": {
                    "ID": childData.ID,
                    "SOWID": childData.SOWID,
                    "IsAllProjects": childData.IsAllProjects,
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "PoNumber": childData.PoNumber,
                    "SoldToID": childData.SoldToID,
                    "ShipToID": childData.ShipToID,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "Owner": childData.Owner,
                    "Email": childData.Email,
                    "EmailGroup": childData.EmailGroup,
                    "Amount": childData.Amount,
                    "IsBillable": childData.IsBillable,
                    "IsActive": childData.IsActive
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };*/

    const handleAmendmentCallback = (childData) => {
        fetch("api/PO/Amendment", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "po_amendment": {
                    "POID": childData.POID,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "Amount": childData.Amount,
                    "AmendmentDate": moment.utc(new Date())
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditAmendmentCallback = (childData) => {
        fetch("api/PO/Amendment", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "po_amendment": {
                    "POID": childData.POID,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "Amount": childData.Amount,
                    "ID": childData.ID
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditLabsProjectsCallback = (childData) => {
        logger(childData);
    };

    React.useEffect(() => {

        if (refresh) {

            fetch('api/PO', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setProductOrders(json);
					setIsLoading(false);
				})

            fetch('api/PO/Amendment', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setamendmentsPo(json))

            setRefresh(false);
        }
    })

    const columns = [];
    if (permissions.CreatePO == 1) {
       	const adminActions =  {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (                        
                        <TableBody >
	                        	<TableRow>
		                        	<TableCell>
			                            <EditPoDialog refreshTab={setRefresh} data={productOrders[dataIndex]} allProductOrders={productOrders}/>
			                        </TableCell>
			                        <TableCell>
			                            <EditPOProjecLabs data={productOrders[dataIndex]} handleLabsProjectsCallback={handleEditLabsProjectsCallback} />
		                            </TableCell>
	                            </TableRow>
                            </TableBody>   
                    );
                }

            }
        };
        columns.push(adminActions);
    }
     const columns1 = [
		 {
            name: "PoNumber",
            label: "PO number",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "CommonName",
            label: "PO Short Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Start Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(productOrders[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(productOrders[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                       parseFloat(productOrders[dataIndex].Amount).toFixed(2)
                    );
                  }
            }
        },
        {
            name: "RemainingAmount",
            label: "Remaining Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        parseFloat(productOrders[dataIndex].remainder).toFixed(2)
                    );
                }
            }
        },
        {
            name: "Billable",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(productOrders[dataIndex].IsBillable) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
        },
        {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },

                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }
                },
               customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(productOrders[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                } 

            }
        }
    ];
    
    columns.push(...columns1);
    

	const getSavedRowsPerPage = () => {
		const savedValue = localStorage.getItem('POrowsPerPage');
		return savedValue ? parseInt(savedValue) : 100; // Default value
	}
	// Save to local storage
	const saveRowsPerPage = (value) => {
		localStorage.setItem('POrowsPerPage', value.toString());
	}

	const initialRowsPerPage = getSavedRowsPerPage();

	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < productOrders.length; i++) {
					var eachRow = data[i].data;
					eachRow[3] =  moment.utc(eachRow[3]).format("MM/DD/YYYY")
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'PO.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => permissions.CreatePO===1 && !isLoading ? (<>
            <PoDialog handleDialogCallback={handleDialogCallback} allProductOrders={productOrders}/>
            <PoAmendmentDialog handleAmendmentCallback={handleAmendmentCallback} />
            </>
        ):(<></>),
        expandableRows: true,
        renderExpandableRow: (rowData, rowMeta) => {
            return (
                <React.Fragment>
                    <tr style={{ backgroundColor: "#FFFFFF" }}>
                        <td colSpan={8}>
                            <Typography variant="h6" gutterBottom component="div"  style={{ backgroundColor: "aliceblue"}}>
                                History for {productOrders[rowMeta.dataIndex].PoNumber}
                            </Typography>
                            <Table size="small" aria-label="TimeLogged">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width:100}}>Admin Actions</TableCell>
                                        <TableCell align="right">Amendment Date</TableCell>
                                        <TableCell align="right">Start Date</TableCell>
                                        <TableCell align="right">End Date</TableCell>
                                        <TableCell align="right">Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {amendmentsPo.filter(obj => { return obj.POID === productOrders[rowMeta.dataIndex].ID }).map((amendment) => (
                                        <TableRow >
                                            <TableCell style={{width:100}}><EditPoAmendmentDialog handleEditAmendmentCallback={handleEditAmendmentCallback} data={amendment} /></TableCell>
                                            <TableCell align="right">{moment.utc(amendment.AmendmentDate).format("MM/DD/YYYY")}</TableCell>
                                            <TableCell align="right">{moment.utc(amendment.StartDate).format("MM/DD/YYYY")}</TableCell>
                                            <TableCell align="right">{moment.utc(amendment.EndDate).format("MM/DD/YYYY")}</TableCell>
                                            <TableCell align="right">{parseFloat(amendment.Amount).toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </td>
                    </tr>
                </React.Fragment>
            );
        }
	};

	// Event listener to save the updated rows
	options.onChangeRowsPerPage = (newRowsPerPage) => {
		saveRowsPerPage(newRowsPerPage);
	};


    return (
        <MuiThemeProvider theme={muiThemeDesign}><Box>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="projectTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Purchase Order Management
                        </Typography>
                    }
                    data={isLoading ? [] :productOrders}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}

                />
            </Box>
        </Box>
        <Dialog
            open={LockedAlert}
            onClose={handleAlertClose}
            aria-labelledby="Date Alert"
            aria-describedby="Duplicate PO with same date range "
        >
            <DialogTitle id="Date Alert">
                {"Alert"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {alertText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
            </DialogActions>
        </Dialog>  
        </MuiThemeProvider>
    );
}